module.exports = "/_next/static/images/home-main-category-idea-4dbf15e4fbf0db7a013f157c4c0bd835.jpg";